if (!customElements.get("gallery-products")) {
  customElements.define(
    "gallery-products",
    class SliderComponent extends HTMLElement {
      constructor() {
        super();

        // Set references
        this.productList = document.getElementById(`GalleryProducts-${this.dataset.sectionId}`);
        this.mediaSlider = document.getElementById(`Slider-${this.dataset.sectionId}`);

        if (!this.productList || !this.mediaSlider) return;

        // Bind events
        this.bindEvents();
      }

      // Bind event handlers
      bindEvents() {
        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.75 // Adjust as needed
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.setActiveProductListItem(entry.target.dataset.mediaId);
            }
          });
        }, observerOptions);

        const mediaItems = this.mediaSlider.querySelectorAll('li');
        mediaItems.forEach(item => {
          observer.observe(item);
        });
      }

      // Set active class on the matching productList item
      setActiveProductListItem(mediaId) {
        const productItems = this.productList.querySelectorAll('li');
        const activeItems = this.productList.querySelectorAll('li.active');
        let itemMatch = false;
        productItems.forEach(item => {
          if (item.dataset.mediaId === mediaId) {
            itemMatch = true;
            if (activeItems) {
              activeItems.forEach(activeItem => {
                activeItem.classList.remove('active');
              });
            }
            item.classList.add('active');
          }
        });
        if(!itemMatch){
          activeItems.forEach(activeItem => {
            activeItem.classList.remove('active');
          });
        }
      }

    }
  );
}